import { Component, OnInit, ViewChild, Inject, AfterViewInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { DocumentService } from 'src/app/core/services/document.service';
import { SubmissionComponent } from '../submission/submission.component';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ToastrService } from 'ngx-toastr';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Message } from 'src/app/core/class/message';

@Component({
  selector: 'app-reject-document',
  templateUrl: './reject-document.component.html'
})
export class RejectDocumentComponent implements OnInit, AfterViewInit, OnDestroy {

  document = {
    id: 0,
    reason: ''
  };

  /**
   * Check success
   */
  success = false;
  userType: any;

  // Refer to form in view
  @ViewChild('f', { static: false }) ngForm: NgForm;
  // Subscribe to form changing
  formChangesSubscription: Subscription;
  // Whether the form change or not
  isFormChanging = false;
  documentEntity: any;
  isCurrentStatus: number = 3;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private documentService: DocumentService,
    public dialogRef: MatDialogRef<SubmissionComponent>,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    private message: Message,
    private toastr: ToastrService,
  ) {
    // Get data from ViewDocumentComponent
    this.document.id = data.id;
    this.documentEntity = data.document;
    dialogRef.disableClose = false;
    this.userType = localStorage.getItem('userType');

  }

  ngOnInit() {
    this.notificationService.subscribeErrorService();
  }

  /**
   * On After Init
   */
  ngAfterViewInit() {
    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });

    // Focus on textarea reason after load
    // There's a problem if not setTimeout it will focus on 'reason' then lost focus right after
    setTimeout(_ => document.getElementById('reason').focus(), 500);
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
    this.notificationService.unsubscribeErrorService();
  }

  /**
   * reject document
   */
  rejectDocument() {
    if (!this.documentEntity.submitedToA && this.documentEntity.status === 0
      // tslint:disable-next-line:max-line-length
        || (!this.documentEntity.submitedToB && (this.documentEntity.status === 4 || this.documentEntity.status === 8) && Number(this.userType) !== 5)) {
        this.documentService.rejectDirectly(this.document) .subscribe(rs => {
          this.success = true;
          this.toastr.success(this.message.getMessage('messages.reject'));
          this.dialogRef.close(this.isCurrentStatus);
        });
    } else {
      this.documentService.reject(this.document) .subscribe(rs => {
        this.success = true;
        this.toastr.success(this.message.getMessage('messages.reject'));
        this.dialogRef.close(this.isCurrentStatus);
      });
    }
  }

  /**
   * Close pop-up
   */
  cancel() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: 'messages.confirm_change_data'
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

}
